import estimate_img from '@/public/article/Accurate-Estimate-Generation.webp';
import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import go_job_img from '@/public/article/On-the-Go-Job-Managment.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/handyman/handyman.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does Orcatec provide free access to the software?',
    text: `Yes, Orcatec offers a free starter package with essential features, perfect for new businesses.`,
  },
  {
    title: 'What are the benefits of Handyman Software for my small business?',
    text: `Handyman software streamlines operations enhances customer service and increases job
    management efficiency. And this makes it best software for handyman business.`,
  },
  {
    title: 'Does your Handyman Software have a mobile app?',
    text: `Yes, Orcatec has a user-friendly mobile app allows you to manage your business on the move.
    So, you can use the comprehensive CRM capabilities to build and manage customer
    relationships effectively, leading to higher satisfaction and retention with its handyman
    business management software.`,
  },
];

const testimonals = [
  {
    text: `The CRM for handyman business feature in Orcatec Software has revolutionized the way
    we connect with our clients. Personalized service histories and tailored communication have led
    to a noticeable increase in repeat business. For a handyman service software, the value it
    provides is exceptional!`,
    name: 'Mark T.,',
    position: 'QuickFix Handyman Services',
  },
  {
    text: `Adopting HandyManager as our go-to handyman service business software was a game-
    changer. From scheduling to invoicing, everything is in one place. It's cut down our admin time
    so we can focus more on the work that matters. Plus, the free starter version was a risk-free
    way to discover its amazing features.`,
    name: 'Alicia R.,',
    position: 'HomeHero Services',
  },
  {
    text: `I was skeptical about any free handyman business software until I tried WorkWise Handyman
    Solutions. It's far more than a CRM – it's like the multi-tool of business management, handling
    all aspects of our operations seamlessly. Even with our diverse range of services, it keeps up
    effortlessly.`,
    name: 'Carlos G.,',
    position: 'All-Around Handyman Group',
  },
  {
    text: `The CRM for handyman business feature in Orcatec Software has revolutionized the way
    we connect with our clients. Personalized service histories and tailored communication have led
    to a noticeable increase in repeat business. For a handyman service software, the value it
    provides is exceptional!`,
    name: 'Mark T.,',
    position: 'QuickFix Handyman Services',
  },
  {
    text: `Adopting Orcatec as our go-to handyman service business software was a game-
    changer. From scheduling to invoicing, everything is in one place. It's cut down our admin time
    so we can focus more on the work that matters. Plus, the free starter version was a risk-free
    way to discover its amazing features.`,
    name: 'Alicia R.,',
    position: 'HomeHero Services',
  },
  {
    text: `I was skeptical about any free handyman business software until I tried Orcatec Handyman
    Solution. It's far more than a CRM – it's like the multi-tool of business management, handling
    all aspects of our operations seamlessly. Even with our diverse range of services, it keeps up
    effortlessly.`,
    name: 'Carlos G.,',
    position: 'All-Around Handyman Group',
  },
];

const industries = {
  title: 'Our industries',
  description: `Orcatec is a flexible platform that is suitable for companies providing field services. We designed our field service management software to meet the diverse needs.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Handyman Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Optimized Dispatch and Scheduling',
      },
      href: '#',
      tag: 'Organized Job Scheduling',
      title: 'Stay on Top of Every Task',
      text: `With our intuitive scheduling calendar, you can keep track of your appointments and avoid
      double bookings. This feature simplifies the planning of your day-to-day tasks, ensuring you
      never miss a beat.`,
      list: [
        { text: 'Keep track of appointments and tasks effortlessly.' },
        { text: 'Avoid double bookings and scheduling conflicts.' },
        { text: 'Plan your day-to-day tasks with ease.' },
        { text: 'Ensure timely service appointments and deliveries.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Customer Relationship Management',
      title: 'Build Lasting Connections',
      text: `With our robust CRM tool, you can maintain all your customer details, job history, and follow-ups
      in one place, fostering long-lasting customer relationships and repeat business.`,
      list: [
        { text: 'Keep comprehensive customer records at your fingertips.' },
        { text: 'Track job history and service interactions effortlessly.' },
        { text: 'Streamline follow-ups for enhanced customer engagement.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: go_job_img,
        alt: 'On-the-Go Job Management',
      },
      href: '#',
      tag: 'On-the-Go Job Management',
      title: 'Stay Connected Anywhere',
      text: `Our mobile app enables you to manage jobs, view schedules, and communicate with customers
      directly from the field, providing the flexibility your business needs.`,

      list: [
        { text: 'Manage jobs efficiently, even while away from the office.' },
        { text: 'Keep track of schedules and updates in real-time.' },
        {
          text: 'Enhance productivity and responsiveness with flexible mobile management.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: estimate_img,
        alt: 'Accurate Estimate Generation',
      },
      href: '#',
      tag: 'Accurate Estimate Generation',
      title: 'Win More Jobs',
      text: `Provide your clients with precise and professional estimates. Our feature allows you to calculate
      costs quickly, adjust as necessary, and send them directly to your customers, enhancing trust
      and transparency.`,
      list: [
        {
          text: `Create and send an accurate estimate before leaving the client's premises.`,
        },
        {
          text: 'Obtain client signatures directly on your smartphone for immediate approval.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Handyman Business Software',
  title: {
    first_part: 'Boost Your Handyman Business with',
    second_part: 'Orcatec',
  },
  description: `Handyman business software provides that efficiency, serving as a digital assistant for
  managing job orders, scheduling, client communications, and invoicing. It streamlines your
  handyman business, ensuring you spend more time turning wrenches and less time wrestling
  with paperwork.`,
  info: [
    { title: '40 hours', description: 'Reduced Monthly Paperwork' },
    { title: '35%', description: 'Workforce Productivity' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1.src,
    alt: 'What is Handyman Software?',
  },
  title: 'What is Handyman Software?',
  description: `Software for Handyman businesses is an all-encompassing digital solution crafted to simplify
  the complexities of managing a handyman business. This innovative tool eases job scheduling,
  enhances client interaction, and automates billing – key concerns for any service provider. It
  addresses the common problem of task juggling by integrating all business functions into one
  platform, tailor-made for the handyman industry.`,
  item: [
    {
      title: 'Increased Productivity',
      description:
        'Automate routine tasks such as scheduling, dispatching, and invoicing so you can focus on more important matters.',
    },
    {
      title: 'Improved Customer Service',
      description:
        'Ensure quick communication with customers, timely invoicing, and quality control of services.',
    },
    {
      title: 'Easy Control of All Processes',
      description:
        'Have quick access to all your business information in one place, from any device.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Orcatec Is Right For You?',
  },
  title: 'Why Orcatec Is Right For You?',
  description: `For contractors, finding handyman management software that not only fits the unique
  demands of your services but also offers flexibility and scalability can be challenging. Orcatec
  stands out as a beacon for your business, providing not just a software solution, but a
  comprehensive platform designed to enhance efficiency, customer satisfaction, and growth.`,
  item: [
    {
      title: 'Free Starter Package',
      description: `Kickstart your business with zero investment and explore the full
      range of features that Orcatec offers without any initial cost.`,
    },
    {
      title: 'Customizable and Scalable',
      description: `Choose the features that fit your business needs and pay
      as you grow. Orcatec's scalable platform is designed to support your business's
      expansion with ease.`,
    },
    {
      title: 'Multi-Device Accessibility',
      description: `Access your business data from any device, at any time.
      Orcatec is available on PCs, tablets, and mobile phones across iOS and Android
      platforms.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Dive into the world of handyman business mastery with our blog. Here, youʼll find expert insights, tips, and stories designed to help you leverage software to elevate your service and streamline your operations.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Take the first step towards operational excellence with Orcatec. Fill out the form below to unlock
  a world of efficiency, customer satisfaction, and business growth. Our team is ready to show
  you how Orcatec can tailor a solution just for you.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
